import { Component, OnInit } from '@angular/core';
import { AuthService } from '@noammazuz/vzn-feathers';
import { appState } from '@services/app-state';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent implements OnInit {
  authUser;
  appState = appState;
  get imageUrl() {
    const { profileImage } = this.authUser;
    return (profileImage) ? this.authUser['profileImage'].url : false;
  }

  get userId() {
    //if (!this.authUser) return ;
    const { _id } = this.authUser;
    return _id;
  }

  constructor(public authService: AuthService<any>) {

  }
  async ngOnInit() {
    this.authUser = await this.authService.getAuthUser();
    this.appState.user = this.authUser;
  }

}
